import * as Yup from 'yup';

export const boozer = Yup.string().max(
  200,
  'Boozer should be less than 200 symbols',
);
